import React, { useEffect } from 'react';
import './index.css';

const d = (props: any) => {


  useEffect(() => { }, []);

  return (
    <div className="tag-d" id={props.id} data-tag={props.tag} >
      <span className={props.className} data-st={props.st} data-et={props.et}>{props.children}</span>
    </div>
  );
};

export default d;
